export {
    default as validationDecoration,
    getValidationStatus,
    ValidationStatus
} from './lib/validationDecoration';
export {
    EMAIL_REGEX,
    PHONE_REGEX,
    NAME_REGEX,
    POSTCODE_REGEX
} from './lib/regex';
